<section>
  <h1 class="mat-display-2">Welcome to Atom</h1>
  <div class="emoji">✌</div>
</section>
